export default __webpack_public_path__ + "static/summer_containers26-3d5438b2b3e299647d79d4a4e980b460.webp";